import React from 'react';
import { getContext } from 'common';
import _merge from 'lodash/merge';
import Styled from './styles';

export interface MultiSelectToolbarDividerProps extends React.ComponentPropsWithRef<'div'> {
  /** Override the theme. See `HorizontalDivider` for theme object. */
  theme?: any;
}

/** Visual Divider between toolbar elements */
const MultiSelectToolbarDivider = React.forwardRef<HTMLElement, MultiSelectToolbarDividerProps>((props: MultiSelectToolbarDividerProps, ref) =>
  getContext(({ theme: globalTheme }) => {
    const { theme, ...otherProps } = props;
    const resolvedTheme = _merge({}, globalTheme && globalTheme.DIVIDER, theme);
    return <Styled.MultiSelectToolbarDivider ref={ref} $theme={resolvedTheme} {...otherProps} />;
  }));

MultiSelectToolbarDivider.defaultProps = {
  theme: undefined
};
MultiSelectToolbarDivider.displayName = 'MultiSelectToolbarDivider';
export default MultiSelectToolbarDivider;
